const translations = {
  en: {
    message: {
      ResetCookie: 'Wrong Info?'
    }
  },
  es: {
    message: {
      ResetCookie: '¿Datos incorrectos?'
    }
  },
  ca: {
    message: {
      ResetCookie: 'Hi ha alguna dada incorrecta?'
    }
  },
  da: {
    message: {
      ResetCookie: 'Forkerte oplysninger?'
    }
  },
  de: {
    message: {
      ResetCookie: 'Falsche Angaben?'
    }
  },
  'en-gb': {
    message: {
      ResetCookie: 'Wrong Info?'
    }
  },
  'es-es': {
    message: {
      ResetCookie: '¿Datos incorrectos?'
    }
  },
  fr: {
    message: {
      ResetCookie: 'Info incorrecte?'
    }
  },
  is: {
    message: {
      ResetCookie: 'Rangar upplýsingar?'
    }
  },
  it: {
    message: {
      ResetCookie: 'Informazione errata?'
    }
  },
  nl: {
    message: {
      ResetCookie: 'Verkeerde informatie?'
    }
  },
  pt: {
    message: {
      ResetCookie: 'Informação Incorreta?'
    }
  },
  sv: {
    message: {
      ResetCookie: 'Fel info?'
    }
  },
}
export default translations;
